import api from './client';

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
}

export interface MailAlias {
  id: number;
  account: number;
  email_address: string;
  display_name: string;
  is_default: boolean;
  created_at: string;
}

export interface MailAccount {
  id: number;
  name: string;
  email_address: string;
  imap_host: string;
  imap_port: number;
  imap_use_ssl: boolean;
  smtp_host: string;
  smtp_port: number;
  smtp_use_tls: boolean;
  username: string;
  is_primary: boolean;
  is_active: boolean;
  aliases?: MailAlias[];
  created_at: string;
  updated_at: string;
}

export const login = (username: string, password: string) =>
  api.post<User>('/auth/login/', { username, password }).then((r) => r.data);

export const logout = () => api.post('/auth/logout/');

export const getMe = () => api.get<User>('/auth/me/').then((r) => r.data);

export const getMailAccounts = () =>
  api
    .get<{ results: MailAccount[]; count: number }>('/auth/mail-accounts/', {
      params: { page_size: 100 },
    })
    .then((r) => r.data);

export const createMailAccount = (data: Record<string, unknown>) =>
  api.post<MailAccount>('/auth/mail-accounts/', data).then((r) => r.data);

export const updateMailAccount = (id: number, data: Record<string, unknown>) =>
  api.patch<MailAccount>(`/auth/mail-accounts/${id}/`, data).then((r) => r.data);

export const deleteMailAccount = (id: number) => api.delete(`/auth/mail-accounts/${id}/`);

export const syncMailAccount = (accountId?: number) =>
  api
    .post<{ detail: string }>('/auth/mail-account/sync/', accountId ? { account_id: accountId } : {})
    .then((r) => r.data);

export const syncMailAccountById = (id: number) =>
  api.post<{ detail: string }>(`/auth/mail-accounts/${id}/sync/`).then((r) => r.data);

export const getAliases = (accountId?: number) =>
  api
    .get<{ results: MailAlias[] }>('/auth/aliases/', {
      params: { page_size: 200, ...(accountId ? { account: accountId } : {}) },
    })
    .then((r) => r.data);

export const createAlias = (data: {
  account: number;
  email_address: string;
  display_name?: string;
  is_default?: boolean;
}) => api.post<MailAlias>('/auth/aliases/', data).then((r) => r.data);

export const updateAlias = (id: number, data: Partial<MailAlias>) =>
  api.patch<MailAlias>(`/auth/aliases/${id}/`, data).then((r) => r.data);

export const deleteAlias = (id: number) => api.delete(`/auth/aliases/${id}/`);
